import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE, delay }}
    >
        {children}
    </motion.div>
);

// Masked line-by-line reveal (Awwwards style). Pass an array of lines.
export const MaskLines = ({
    lines,
    className = "",
    lineClassName = "",
    delay = 0,
    stagger = 0.12,
    animateOnLoad = true,
}) => {
    const anim = animateOnLoad
        ? { animate: { y: "0%" } }
        : {
              whileInView: { y: "0%" },
              viewport: { once: true, margin: "-60px" },
          };
    return (
        <span className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden">
                    <motion.span
                        className={`block ${lineClassName}`}
                        initial={{ y: "110%" }}
                        {...anim}
                        transition={{
                            duration: 1.1,
                            ease: [0.76, 0, 0.24, 1],
                            delay: delay + i * stagger,
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
};

export { EASE };
